import { useEffect } from "react";
import { useForm } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";

import { useIntoleranceMutations } from "features/patients/hooks/useIntoleranceMutations";
import { onInvalidSubmit } from "utils/reportFormErrors";

import { DEFAULT_VALUES } from "../utils/constants";
import { intoleranceFormSchema } from "../utils/intoleranceFormSchema";

export const useIntoleranceForm = ({ isOpen, editId, data, patientId, onClose }) => {
  const { createOrUpdateIntolerance } = useIntoleranceMutations(patientId);

  const selectedItem = editId !== null ? data.find((item) => item.id === editId) : null;
  const isItemDisabled = !!selectedItem?.disabled;

  const form = useForm({
    resolver: zodResolver(intoleranceFormSchema),
    defaultValues: DEFAULT_VALUES,
  });

  useEffect(() => {
    if (isOpen) {
      if (selectedItem) {
        form.reset({
          name: selectedItem.name ?? "",
          allergyReaction: selectedItem.allergyReaction ?? "RASH",
          serious: selectedItem.serious ?? false,
          note: selectedItem.note ?? null,
        });
      } else {
        form.reset(DEFAULT_VALUES);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isOpen, editId]);

  const handleClose = () => {
    form.reset(DEFAULT_VALUES);
    onClose();
  };

  const onSubmit = (values) => {
    createOrUpdateIntolerance.mutate(
      {
        id: editId ?? null,
        name: values.name,
        allergyType: "INTOLERANCE",
        allergyReaction: values.allergyReaction,
        serious: values.serious,
        ...(values.note !== null && { note: values.note }),
      },
      { onSuccess: handleClose }
    );
  };

  return {
    form,
    isItemDisabled,
    handleClose,
    handleSubmit: form.handleSubmit(onSubmit, onInvalidSubmit("useIntoleranceForm")),
    isPending: createOrUpdateIntolerance.isPending,
  };
};
